import { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import Header from '../Header/Navbar';
import Footer from '../Footer/Footer';
import { merchantTermsMarkdown } from './merchantTermsContent';

export default function MerchantTerms() {
  const [markdown, setMarkdown] = useState(merchantTermsMarkdown);

  // Load from markdown file in public folder, with fallback to imported content
  useEffect(() => {
    fetch('/merchant-terms.md')
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
        throw new Error('Failed to load markdown');
      })
      .then((text) => {
        setMarkdown(text);
      })
      .catch(() => {
        // Fallback to imported content if markdown file is not found
        setMarkdown(merchantTermsMarkdown);
      });
  }, []);

  return (
    <div>
      <Header />
      <div className="container mx-auto py-16 px-4 max-w-4xl">
        <div className="prose prose-lg max-w-none">
          <ReactMarkdown
            components={{
              h1: ({ node, ...props }) => (
                <h1 className="text-4xl font-bold text-primary mb-8 font-sora" {...props} />
              ),
              h2: ({ node, ...props }) => (
                <h2 className="text-2xl font-semibold text-primary mb-4 mt-8 font-sora" {...props} />
              ),
              h3: ({ node, ...props }) => (
                <h3 className="text-xl font-semibold text-primary mb-3 mt-6 font-sora" {...props} />
              ),
              p: ({ node, ...props }) => (
                <p className="text-primary mb-4 font-noto leading-relaxed" {...props} />
              ),
              ul: ({ node, ...props }) => (
                <ul className="list-disc pl-6 mb-4 space-y-2 font-noto text-primary" {...props} />
              ),
              li: ({ node, ...props }) => (
                <li className="font-noto text-primary" {...props} />
              ),
              ol: ({ node, ...props }) => (
                <ol className="list-decimal pl-6 mb-4 space-y-2 font-noto text-primary" {...props} />
              ),
            }}
          >
            {markdown}
          </ReactMarkdown>
        </div>
      </div>
      <Footer />
    </div>
  );
}
